import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { GrundbuchblattEditDialog } from './GrundbuchblattEditDialog';

/**
 * Routen-Wrapper für /grundstuecke/:idGrundbuchblatt — öffnet den Blatt-Editor
 * direkt als Modal über der Übersicht (analog EditLegalClientDialog bei
 * /clients/:legalClientId), statt einer read-only Zwischenansicht. Schließen
 * navigiert zurück zur Liste; nach dem Speichern wird zusätzlich die
 * Trefferliste invalidiert, damit Änderungen sofort sichtbar sind.
 */
export const GrundbuchblattEditRoute: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { idGrundbuchblatt } = useParams();
  const gid = Number(idGrundbuchblatt);

  return (
    <GrundbuchblattEditDialog
      open
      idGrundbuchblatt={Number.isFinite(gid) && gid > 0 ? gid : null}
      onClose={() => navigate('/grundstuecke')}
      onSaved={() => {
        queryClient.invalidateQueries({
          queryKey: ['grundbuchblatt', 'search'],
        });
        navigate('/grundstuecke');
      }}
    />
  );
};
